import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { userDetails } from "store/authSlice";
import { isTokenValid } from "./tokenUtils";

export const useAuthInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (isTokenValid(token)) {
      dispatch(userDetails({ token }));
    } else {
      localStorage.removeItem("token");
    }
  }, []);
};
